import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, EMOB_INVEST_IMAGE_UPLOAD_FIELD_PROPS, FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const SonstigeInformationAntragEmobInvest: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Sonstige Information' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0167902019_ationen_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0165473010_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0167110573_en_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0127455972_ormationen_Pruefung_Erledigt.path
				}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};
export default SonstigeInformationAntragEmobInvest;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0127455972_ormationen_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0040348391_umme_Und_Jahr_Der_Foerderung,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0020704734_rderrelevanter_Informationen,
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0109936114_onstige_Informationen_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...EMOB_INVEST_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

export const getFormStrucSonstigeInformationAntragEmobInvest = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0167902019_ationen_Pruefung_Pruefstatus.path,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0127455972_ormationen_Pruefung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	else return concat(formStruc());
};
